/**
 * Detect questionnaire date items that record when a form was signed.
 * Other date questions (DOB, request date, expiration, etc.) stay client-editable.
 */

const SIGNATURE_DATE_PATTERNS: RegExp[] = [
  /\bdate[\s._:-]*signed\b/i,
  /\bsign(ature|ed)?[\s._:-]*date\b/i,
  /\bdate[\s._:-]*of[\s._:-]*signature\b/i,
];

export function isSignatureDateLabel(label: string | undefined | null): boolean {
  const text = label?.trim();
  if (!text) return false;
  return SIGNATURE_DATE_PATTERNS.some((re) => re.test(text));
}

export function isSignatureDateQuestion(item: {
  text?: string;
  linkId?: string;
}): boolean {
  return isSignatureDateLabel(item.text) || isSignatureDateLabel(item.linkId);
}
